<template>
    <transition name="fade">

        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Share with us some information</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Select Purpose of Loan<b class="danger fs-17">*</b></label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.loan_purpose_code" :class="{'is-invalid': submitting && $v.formLoan.loan_purpose_code.$error}">
                                        <option selected disabled :value='null'>- Select -</option>
                                        <option v-for="(x, index) in filterPurpose" :key="index" :value="x.loan_purpose_code">{{x.loan_purpose_desc}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="formLoan.loan_purpose_code=='LP-014'">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Other Purpose</label>
                                    <input class="form-control text-uppercase" type="text" v-model="formLoan.loan_purpose_other" @input="formLoan.loan_purpose_other=$event.target.value.toUpperCase().trim()" :class="{'is-invalid': submitting && $v.formLoan.loan_purpose_other.$error}" />
                                </div>
                            </div>
                        </div>

                        <div v-if="formLoan.loan_purpose_code">
                            <hr>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Firm Size<b class="danger fs-17">*</b> (Total assets exclusive of the land on which the business entity's office, plant and equipment are situated.)</label>
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                            </div>
                                            <input type="number" v-model="formLoan.asset_size" class="form-control" :class="{'is-invalid': submitting && $v.formLoan.asset_size.$error}" />
                                        </div>
                                        <div>
                                            <small class="text-grey float-right bold">{{convertedAsset}}</small>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Firm Classification</label>
                                        <input type="text" class="form-control" disabled :value="firmClass.class_desc">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Annual Sales or Revenue<b class="danger fs-17">*</b></label>
                                        <input type="text" class="form-control" v-model="formLoan.annual_sale" :class="{'is-invalid': submitting && $v.formLoan.annual_sale.$error}">
                                        <small class="text-grey float-right bold">{{convertedAnnual}}</small>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Monthy Income<b class="danger fs-17">*</b></label>
                                        <input type="text" class="form-control" v-model="formLoan.owners_monthly_income" :class="{'is-invalid': submitting && $v.formLoan.owners_monthly_income.$error}">
                                        <small class="text-grey float-right bold">{{convertedMonthly}}</small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>No. of Cars Owned<b class="danger fs-17">*</b></label>
                                        <input type="text" class="form-control" v-model="formLoan.num_cars_owned" :class="{'is-invalid': submitting && $v.formLoan.num_cars_owned.$error}">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="btnNext">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import {
  apiRefPurposeFirmRegistry,
  apiPostFirmLoanClass,
  apiGetCarinaLoanble,
} from "@js/api/applyLoanApi";
import moment from "moment";
import {
  required,
  minLength,
  requiredIf,
  minValue,
  helpers,
} from "vuelidate/lib/validators";

const validateIf = (prop, validator) =>
  helpers.withParams(
    {
      type: "validatedIf",
      prop,
    },
    function (value, parentVm) {
      return helpers.ref(prop, this, parentVm) ? validator(value) : true;
    }
  );

export default {
  props: ["formLoan", "user"],

  data() {
    return {
      submitting: false,
      firm: [],
      purposes: [],
      firm_class: "-",
    };
  },

  validations: {
    formLoan: {
      asset_size: {
        required,
      },
      annual_sale: {
        required,
      },
      owners_monthly_income: {
        required,
      },
      num_cars_owned: {
        required,
      },

      loan_purpose_code: {
        required,
      },
      loan_purpose_other: {
        required: requiredIf(function (obj) {
          return this.formLoan.loan_purpose_code == "LP-014";
        }),
      },
    },
  },

  computed: {
    name_borrower() {
      if (!this.user) {
        return ""; // Return an empty string if user is not defined
      }
      const { fname, mname, lname, suffix_desc } = this.user;
      let nameParts = [fname, mname, lname, suffix_desc].filter((part) => part); // Filter out undefined or null parts
      return nameParts.join(" ").trim();
    },
    firmClass() {
      const val = parseFloat(this.formLoan.asset_size);
      if (isNaN(val)) return {}; // Return an empty object if asset_size is not a number
      return this.firm.find((entry) => val <= entry.upper_limit) || {};
    },
    convertedAnnual() {
      let val = this.formLoan.annual_sale;
      if (val > 0) {
        let num_parts = val.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      } else {
        return "";
      }
    },
    convertedMonthly() {
      let val = this.formLoan.owners_monthly_income;
      if (val > 0) {
        let num_parts = val.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      } else {
        return "";
      }
    },
    convertedAsset() {
      let val = this.formLoan.asset_size;
      if (val > 0) {
        let num_parts = val.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num_parts.join(".");
      } else {
        return "";
      }
    },
    filterPurpose() {
      let arr = this.purposes;
      if (arr) {
        arr = arr.filter(function (item) {
          return item.riseup == 1;
        });
      }
      return arr;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    apiGetCarinaLoanable() {},

    async initData() {
      this.$emit("load", 1);

      const name = this.name_borrower;
      const business = this.formLoan.business_name;
      const app_id = this.formLoan.application_id;

      try {
        const { firm, purposes } = await apiRefPurposeFirmRegistry();
        const { loanable } = await apiGetCarinaLoanble(name, business, app_id);

        this.firm = firm;
        this.purposes = purposes;
        this.formLoan.max_loan = loanable;
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.$emit("load", -1);
      }
    },

    async apiSubmit() {
      const form = {
        application_id: this.formLoan.application_id,
        loan_purpose_code: this.formLoan.loan_purpose_code,
        loan_purpose_other: this.formLoan.loan_purpose_other,
        asset_size: this.formLoan.asset_size,
        annual_sale: this.formLoan.annual_sale,
        owners_monthly_income: this.formLoan.owners_monthly_income,
        num_cars_owned: this.formLoan.num_cars_owned,
        max_loan: this.formLoan.max_loan,
        firm_class_id: this.firmClass.id,
      };
      try {
        this.$emit("load", 1);
        const res = await apiPostFirmLoanClass(form);
        this.$emit("next");
      } catch (error) {
        this.$emit("error", error);
      } finally {
        this.$emit("load", -1);
      }
    },

    btnNext() {
      this.submitting = true;
      this.$v.formLoan.$touch();
      if (this.$v.formLoan.$invalid) {
        const err = {
          response: {
            data: {
              message: "Please complete all required fields",
            },
          },
        };
        this.$emit("error", err);
      } else {
        this.apiSubmit();
      }
    },
  },
  mounted() {},
};
</script>